<p>
  You may add an additional retirement date for comparing. Additional retirement
  dates should fall between earliest retirement date above and prior to December 1 of the calendar year in which you turn age 71.
</p>
